import React, { useEffect, useState } from 'react'
import * as SC from './styles'
import { useRouter } from 'next/router'
import Script from 'next/script'
interface Props {
  content: string | null
}

const vkRegex = /VK\.Widgets\.Playlist\("(.+)",\s?(-?\d+)\s?,\s?(\d+)\s?,\s?'(.*)'\);/i

const EmbedContent = (props: Props): JSX.Element => {
  const { content } = props
  const router = useRouter()
  const [isLoaded, setIsLoaded] = useState(false)
  const [isContentDrawn, setIsContentDrawn] = useState(false)
  const [currentFrame, setCurrentFrame] = useState<React.ReactNode>()

  useEffect(() => {
    if (!isContentDrawn && (isLoaded || window.VK)) {
      if (!content) {
        return
      }

      setIsContentDrawn(true)

      const vkMatch = content.match(vkRegex)
      if (vkMatch && typeof window !== 'undefined' && window.VK) {
        const [, elementId, ownerId, playlistId, hash] = vkMatch
        setCurrentFrame(<SC.EmbedContentWrapper id={elementId}></SC.EmbedContentWrapper>)
        window.VK.Widgets.Playlist(elementId, Number(ownerId), Number(playlistId), hash)
      } else if (content.match(/<iframe/i)) {
        setCurrentFrame(
          <SC.EmbedContentWrapper
            dangerouslySetInnerHTML={{
              __html: `${content}`
            }}
          />
        )
      } else {
        setCurrentFrame(<SC.EmbedContentWrapper hasError>{'Ошибка получения плейлиста'}</SC.EmbedContentWrapper>)
      }
    }
  }, [isLoaded])

  return (
    <>
      <Script
        type="text/javascript"
        src="https://vk.com/js/api/openapi.js?169"
        onLoad={() => {
          setIsLoaded(true)
        }}
      />

      <>{currentFrame}</>
    </>
  )
}

export default EmbedContent
